import React, { Component } from "react";
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'

class TourToGuide extends Component {
    state={

    }
    tourToGuideSubmit = () => {
        const { user:{ auth }, tourContentPlan, location:{ pathname }} = this.props
        const tourType = pathname.split("/")[1]
        this.props.dispatch({ type: `set${tourType}Tour`, [`is${tourType}TourActive`]: false })
        if(auth === "notSignIn" ) this.props.dispatch({ type: "toggleUserField", condition: "signIn" })
        else {
            this.props.dispatch({ 
                type: 'togglePaymentField', 
                isPaymentGuideActive: true,
                paymentGuideMinPlan: tourContentPlan,})
        }
    }
    render() {
        const { user:{ auth, plan }, messages, title, tourContentPlan} = this.props
        const {tourToGuideSubmit} = this
        const plansOrder = {
            Free: 1,
            Creator: 2,
            Brand: 3,
            Agency: 4
        }
        return (
            <Container>
                {title}
                {auth === "notSignIn" 
                    ? <Content
                        id={"ga_login_user_tour"}
                        isActive 
                        onClick={() => tourToGuideSubmit()}>
                            (<span>{messages.guide_banner_login}</span>)
                        </Content>
                    : <Content 
                        id={"ga_upgrade_user_tour"}
                        isActive={plansOrder[tourContentPlan] > plansOrder[plan]}
                        onClick={() => tourToGuideSubmit()}>
                            (<span>{messages.guide_banner_upgrade}</span>)
                        </Content>}
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        user: state.User,
        payment: state.Payment,
        tour: state.Tour,
    }
}
export default withRouter(connect(mapStateToProps)(TourToGuide));
const Container = styled.div`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
`
const Content = styled.div`
    display: ${({ isActive }) => isActive ? "inline-flex" : "none"};
    color: #e94242;
    margin-left: 5px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    span {
        text-decoration: underline;
    }
`


// WEBPACK FOOTER //
// ./src/Tour/TourToGuide.js